import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import React from 'react';

interface IDeleteCardConfirmationDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	removeToken: () => void;
}

const DeleteCardConfirmationDialog = ({ isOpen, hideDialog, removeToken }: IDeleteCardConfirmationDialogProps) => {
	const deleteCard = () => {
		hideDialog();
		removeToken();
	};

	return (
		<ConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			header={translate('wallet.confirmation.delete.card')}
			dialogBody={
				<div>
					<BodyS color="primary-light">{translate('wallet.confirmation.are.you.sure')}</BodyS>
				</div>
			}
			buttons={[
				{
					text: translate('cancel'),
					onClick: hideDialog,
					color: 'tertiary-light',
				},
				{
					text: translate('wallet.delete'),
					onClick: deleteCard,
					color: 'primary-light',
				},
			]}
		/>
	);
};

export default DeleteCardConfirmationDialog;
